export default __webpack_public_path__ + "static/media/team.e11e6df1.png";